import { useTranslation } from '@/i18n';
import { useGlobalContainerRef } from '@/wc/helper/ref';
import {
  ButtonV2,
  ListView,
  ListViewBody,
  ListViewLabel,
  Loading,
  Single,
  TextLink,
} from '@moneyforward/ap-frontend-components';
import classnames from 'classnames/bind';
import { useCallback } from 'react';
import styles from './BusinessDocumentSetting.module.scss';
import { Container } from './components/Container/Container';
import {
  useDisableConfirmModal,
  useEnableConfirmModal,
  useSubmitBusinessDocumentSetting,
} from './hooks';

const cx = classnames.bind(styles);

export const BusinessDocumentSetting = () => {
  const flagshipUrl = '/billing_history';
  const { t } = useTranslation();
  const containerRef = useGlobalContainerRef();

  const { isEnabled, submitEnableSetting, submitDisableSetting, isLoading } =
    useSubmitBusinessDocumentSetting();

  const { confirm: confirmEnable, ConfirmModal: EnableConfirmModal } =
    useEnableConfirmModal();
  const { confirm: confirmDisable, ConfirmModal: DisableConfirmModal } =
    useDisableConfirmModal();

  const handleClick = useCallback(async () => {
    if (isEnabled) {
      const confirmed = await confirmDisable();
      if (confirmed) {
        await submitDisableSetting();
      }
    } else {
      const confirmed = await confirmEnable();
      if (confirmed) {
        await submitEnableSetting();
      }
    }
  }, [
    isEnabled,
    confirmDisable,
    confirmEnable,
    submitDisableSetting,
    submitEnableSetting,
  ]);

  return (
    <>
      <Loading
        isDialogMode
        open={isLoading}
        getContainer={containerRef}
        size='xlarge'
        color='white'
      />
      <Container>
        <div className={cx(styles['list-header-container'])}>
          <div className={cx(styles['section-heading'])}>
            {t('business_document_setting_title')}
          </div>
          <div className={cx(styles['description-container'])}>
            <div className={cx(styles['description-inner'])}>
              <div className={cx(styles['description'])}>
                {t('business_document_setting_description')}
              </div>
              <TextLink href={flagshipUrl}>
                {t('business_document_setting_history')}
              </TextLink>
            </div>
            <ButtonV2
              color='primary'
              isSecondary
              type='button'
              onClick={handleClick}
              isDisabled={isLoading}
            >
              {t(isEnabled ? 'use_end' : 'use_start')}
            </ButtonV2>
          </div>
        </div>
        <ListView>
          <Single>
            <ListViewLabel>
              <div className={cx(styles['label'])}>
                {t('business_document_setting_use_function')}
              </div>
            </ListViewLabel>
            <ListViewBody>{t(isEnabled ? 'use' : 'not_use')}</ListViewBody>
          </Single>
        </ListView>
      </Container>
      <EnableConfirmModal />
      <DisableConfirmModal />
    </>
  );
};
